import { render, staticRenderFns } from "./FeedTxItems.vue?vue&type=template&id=4d981f1e&"
import script from "./FeedTxItems.vue?vue&type=script&lang=js&"
export * from "./FeedTxItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d981f1e')) {
      api.createRecord('4d981f1e', component.options)
    } else {
      api.reload('4d981f1e', component.options)
    }
    module.hot.accept("./FeedTxItems.vue?vue&type=template&id=4d981f1e&", function () {
      api.rerender('4d981f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FeedTxItems.vue"
export default component.exports